import { ru } from '../../data/ru';
import { by } from '../../data/by';
import './message.css'
import './admin.css'

import API from '../../API';
import { useEffect, useState } from 'react';

export default function Message(){
    const api = new API()
    const language = localStorage.getItem('lang') === 'ru' ?  ru.RoleIdOne: by.RoleIdOne;

    const [messages, setMessages] = useState([])
	
    useEffect(() => {
        api.getFeedback().then(result => {
            if(!result) {return}
            setMessages(result)
        })
    },[])

    function deleteFeedback(idFeedback) {
        api.closeFeedback(idFeedback)
        .then(setMessages(messages => messages.filter(item => item.id !== idFeedback)))
    }

    function getAllFeedback() {
        api.getAllFeedback().then(result => {
            if(!result) {return}
            setMessages(result);
        })
    }

    const messageList = messages.map(item=>{
                return (
                <div key={`key-${item.id}`}>
                    <hr/>
                        {/* <div  className="admin_new-task-mesenger-flex">
                            <a className='admin_message-email' href={`mailto:${item.email}`}>{item.email}</a> 
                            <div className="admin_mess_del_flex">
                                <pre className='admin_message-message'>{item.message}</pre>
                                <button className="admin_del-button" onClick={() => deleteFeedback(item.id)}>&times;</button>
                            </div>
                        </div> */}
                        <div style={{position: 'relative'}}>
                            {/* <a className='admin_message-email' href={`mailto:${item.email}`}>{item.email}</a> 
                            <div className="admin_mess_del_flex"> */}
                                <a style={{textDecoration: 'none'}} href={`mailto:${item.email}`}><pre className='admin_message-message'>{item.message}</pre></a>
                                <button className="admin_message_del-button" onClick={() => deleteFeedback(item.id)}>&times;</button>
                            {/* </div> */}
                        </div>
                    <hr/>
                </div>
                )
            })

    return (
        <div className='admin_messages-wrapper'>
            <p style={{fontSize: '23px'}}>{language.message}:</p><br/>
            (Нажмите чтобы ответить пользователю)
            {messageList}
            <button className="admin_message_show_button" onClick={getAllFeedback}>{language.showAllPost}</button>
        </div>
    )
}